import { createContext, useContext, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Society } from '../services/API/Entities/society'
import { useLocation } from 'react-router-dom'

export const ParametersContext = createContext(null)

export const ParametersProvider = ({ children }) => {
    const location = useLocation()

    const {
        data: parameters,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['parameters'],
        queryFn: async () => {
            return await Society.fetchParameters()
        },
        enabled: location.pathname !== '/',
        retry: 0,
    })

    const value = {
        parameters,
        isLoading,
        error,
    }

    return (
        <ParametersContext.Provider value={value}>
            {children}
        </ParametersContext.Provider>
    )
}

export const useParameters = () => useContext(ParametersContext)
